import React from "react";
import {useParams} from 'react-router-dom';
import Menu from './Menu';
import Orderlog from '../components/orderlog/OrderLog';

export default function Orderlogfinal (){
  let { id } = useParams()
    return(
      <div style={{backgroundColor:"white",height:"auto",width:"auto"}}>
        <div>
          <Menu />
        </div> 
        <div>
            <Orderlog orderId = {id} />
        </div>
      </div>
    );
}
